import { Column } from 'app/design/primitives/box';
import { NotificationSection } from './notification-section';
import { useTranslation } from 'react-i18next';
import { NeedToggleCard } from './need-toggle-card';
import type { NeedToggle } from './notification-toggle.types';
import { ResponsiveSectionTitle } from './responsive-section-title';

export const NeedNotificationSection = ({
  isLargeUI,
  toggles,
  usesSectorNeedSources,
}: {
  isLargeUI: boolean;
  toggles: NeedToggle[];
  usesSectorNeedSources: boolean;
}) => {
  const { t } = useTranslation('notifications-setting');
  return (
    <NotificationSection
      separated
      title={<ResponsiveSectionTitle {...{ isLargeUI }}>{t('needTitle')}</ResponsiveSectionTitle>}
      description={t('needHelp')}
    >
      <Column gap="spacing.general.x4">
        {toggles.map((toggle) => (
          <NeedToggleCard key={toggle.label} {...{ toggle, usesSectorNeedSources }} />
        ))}
      </Column>
    </NotificationSection>
  );
};
